var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "DEFENDING",
    className: "cls-1",
    d: "M-347.637,7210.376a18.862,18.862,0,0,0-13.435-5.565,18.862,18.862,0,0,0-13.435,5.565,18.871,18.871,0,0,0-5.565,13.436,18.887,18.887,0,0,0,5.565,13.435,18.883,18.883,0,0,0,13.435,5.564,18.883,18.883,0,0,0,13.435-5.564,18.888,18.888,0,0,0,5.565-13.435A18.871,18.871,0,0,0-347.637,7210.376Zm4.107,13.436a17.411,17.411,0,0,1-4.634,11.876l-11.877-11.876,11.877-11.881A17.423,17.423,0,0,1-343.53,7223.812Zm-5.665-12.91-11.877,11.877-11.877-11.877a17.427,17.427,0,0,1,11.877-4.632A17.427,17.427,0,0,1-349.194,7210.9Zm-29.419,12.91a17.424,17.424,0,0,1,4.634-11.881l11.877,11.881-11.877,11.876A17.412,17.412,0,0,1-378.613,7223.812Zm5.664,12.905,11.877-11.879,11.877,11.879a17.414,17.414,0,0,1-11.877,4.635A17.414,17.414,0,0,1-372.949,7236.717Z",
    transform: "translate(380.071 -7204.811)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefending);
export default __webpack_public_path__ + "static/media/defending.55d3dd7946cd67aaf1a27354fb533947.svg";
export { ForwardRef as ReactComponent };